import React from 'react';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Register required components
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);


const getBarColor = (correctCount) => {
    return correctCount >= 24 ? "rgba(0, 200, 0, 0.6)" : "rgba(255, 0, 0, 0.6)"; // Green for Pass, Red for Fail
};

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

const TrainingSessionChart = ({ trainingSessionList,translate }) => {
    // Prepare chart data
    const labels = trainingSessionList.map((session) => formatDate(session.createdAt));
    const totalCounts = trainingSessionList.map((session) => session.totalCount);
    const correctCounts = trainingSessionList.map((session) => session.correctCount);

    const getResultLabel = (correctCount) => {
        return correctCount < 24 ? translate("Fail") : translate("Pass");
    };

    const data = {
        labels, // X-axis labels (dates)
        datasets: [
            // {
            //     label: 'Total Count',
            //     data: totalCounts,
            //     backgroundColor: 'rgba(75, 192, 192, 0.6)', // Light blue
            //     borderColor: 'rgba(75, 192, 192, 1)', // Darker blue
            //     borderWidth: 1,
            // },
            {
                data: totalCounts,
                backgroundColor: correctCounts.map(getBarColor), // Light purple
                borderColor: correctCounts.map((correct) => correct >= 24 ? "green" : "red"), // Darker purple
                borderWidth: 1,
                label: undefined,
            },
            {
                label: translate('Pass'),
                backgroundColor:'rgba(0, 200, 0, 0.6)',
            },
            {
                label: translate('Fail'),
                backgroundColor:'rgba(255, 0, 0, 0.6)',
            }
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top', // Legend position
                labels: {
                    filter: (legendItem) => {
                        // Hide the 'correctCounts' dataset in the legend
                        return legendItem.datasetIndex !== 0;
                    }
                }
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const index = tooltipItem.dataIndex;
                        const correct = correctCounts[index];
                        const result = getResultLabel(correct);
                        return `Result: ${correct}/40 ${result}`;
                    }
                }
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Date', // X-axis title
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Count', // Y-axis title
                },
                beginAtZero: true, // Start y-axis from 0
            },
        },
    };

    return (
        <>
            <Bar data={data} options={options} />
        </>
    );
};

export default TrainingSessionChart;
